<template>
  <div class="im-main">
    <imFriends @onChange="onChange" />
    <imDialog v-if="dialogShow" v-model="dialogShow" :dialogProps="dialogProps" :curUserId="userInfo.userId" />
    <el-empty class="empty" description="请选择对话" v-else></el-empty>
  </div>
</template>
<script>
import imFriends from "./im-friends.vue";
import imDialog from "./im-dialog.vue";

export default {
  components: {
    imFriends,
    imDialog,
  },
  name: "im",
  data() {
    return {
      dialogProps: undefined,
      dialogShow: false,
      userInfo: {},
    };
  },
  methods: {
    getUser() {
      return this.$http.get("im/users/getUser");
    },
    onChange(item) {
      if (item.id !== this.dialogProps?.id && this.dialogShow) {
        this.dialogShow = false;
        this.dialogProps = item;
        setTimeout(() => {
          this.dialogShow = true;
        }, 200);
      } else {
        this.dialogProps = item;
        this.dialogShow = true;
      }
    },
  },
  mounted() {
    this.getUser().then(({ data: res }) => {
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    });
  },
};
</script>
<style scoped lang="less">
.im-main {
  display: flex;
  flex-direction: row;
  padding: 20px;
  background: #e1e1e1;
  height: calc(100vh - 119px);
  .empty {
    flex: 1;
  }
}
</style>
